export const INTERCOM_PROVIDER = "intercom_support"
export const ZENDESK_PROVIDER = "zendesk_support"

export const providerNameMapping = {
  [ZENDESK_PROVIDER]: 'Zendesk',
  [INTERCOM_PROVIDER]: 'Intercom'
}

export const getCurrentProviderName = (dataset_source) => providerNameMapping[dataset_source] || ZENDESK_PROVIDER;

export function getDefaultConnector(connectors) {
  if (!connectors || connectors.length === 0) return null;
  return (connectors.length === 1) ? connectors[0] : connectors.find((c) => c.authenticated);
}
